import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ConfirmationAmount from './ConfirmationAmount';
import ConfirmationAmountGiftAid from './ConfirmationAmountGiftAid';

export class ConfirmationMessage extends Component {
  render() {
    const {
      yourDonation,
      giftaidFlag,
      extraDonateAmount,
      giftAid,
    } = this.props;

    return (
      <div className="confirmation_header" tabIndex="0">
        <ConfirmationAmount message={yourDonation} />
        {giftaidFlag && (
          <ConfirmationAmountGiftAid
            extraDonateAmount={extraDonateAmount}
            giftAid={giftAid}
          />
        )}
      </div>
    );
  }
}

export default ConfirmationMessage;

ConfirmationMessage.propTypes = {
  yourDonation: PropTypes.string,
  giftaidFlag: PropTypes.bool,
  extraDonateAmount: PropTypes.string,
  giftAid: PropTypes.string,
};
